import { render } from "./Advertizing.vue?vue&type=template&id=79b4136f&scoped=true"
import script from "./Advertizing.vue?vue&type=script&lang=js"
export * from "./Advertizing.vue?vue&type=script&lang=js"

import "./Advertizing.vue?vue&type=style&index=0&id=79b4136f&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b4136f"]])

export default __exports__